// Signup.container: account-type hub and nested signup flows (agency, school, student, koach) by route.
// Mistake: student register path assumed only wizard; add /register/oauth-link for OAuth→email link outside wizard.
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import AgencySignupPre from "./AgencySignupPre.container";
import AgencySignup from "./AgencySignup.container";
import SchoolSignup from "./SchoolSignup.container";
import StudentSignupPre from "./StudentSignupPre.container";
import StudentSignup from "./StudentSignup.container";
import StudentOauthLinkContainer from "./StudentOauthLink.container";

import SignupComponent from "./Signup.component";
import KoachSignup from "./koach/KoachSignup";

const SignupContainer = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [studentStep, setStudentStep] = useState(0); // 1 = 지망생 본가입(/signup/student/register)
  const [agencyStep, setAgencyStep] = useState(0);
  const [selectedAgencyInfo, setSelectedAgencyInfo] = useState<any>(null);

  const code = location.pathname.split("/")[2];
  const [accountTypeCode, setAccountTypeCode] = useState(
    code ? `accountType:${code}` : ""
  );

  const cancelSignup = () => {
    setAccountTypeCode("");
    navigate("/signup");
  };

  useEffect(() => {
    if (location.pathname === "/signup") {
      setAccountTypeCode("");
    } else if (location.pathname.includes("/signup/")) {
      const accountTypeCode = `accountType:${location.pathname.split("/")[2]}`;
      setAccountTypeCode(accountTypeCode);
      if (location.pathname.startsWith("/signup/student/register")) {
        setStudentStep(1);
      } else {
        setStudentStep(0);
      }
      setAgencyStep(0);
    }
  }, [location]);

  return !accountTypeCode ? (
    <SignupComponent setAccountTypeCode={setAccountTypeCode} backUrl="/" />
  ) : (
    <>
      {accountTypeCode === "accountType:agency" ? (
        agencyStep === 0 ? (
          <AgencySignupPre
            setAgencyStep={setAgencyStep}
            selectedAgencyInfo={selectedAgencyInfo}
            setSelectedAgencyInfo={setSelectedAgencyInfo}
          />
        ) : (
          <AgencySignup
            cancelSignup={cancelSignup}
            selectedAgencyInfo={selectedAgencyInfo}
            accountTypeCode={accountTypeCode}
          />
        )
      ) : accountTypeCode === "accountType:school" ? (
        <SchoolSignup
          cancelSignup={cancelSignup}
          accountTypeCode={accountTypeCode}
        />
      ) : accountTypeCode === "accountType:student" ? (
        location.pathname.includes("/register/oauth-link") ? (
          <StudentOauthLinkContainer cancelSignup={() => navigate("/signup/student")} />
        ) : studentStep === 0 ? (
          <StudentSignupPre />
        ) : (
          <StudentSignup
            cancelSignup={cancelSignup}
            accountTypeCode={accountTypeCode}
          />
        )
      ) : accountTypeCode === "accountType:koach" ? (
        <KoachSignup
          cancelSignup={cancelSignup}
          accountTypeCode={accountTypeCode}
        />
      ) : null}
    </>
  );
};

export default SignupContainer;
